import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { updateFilters } from "../store/documentsSlice";
import { selectDocumentsFilters } from "../store/documentsSelectors";

export const DocumentFilters: React.FC = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectDocumentsFilters);

  const handleSearchChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(updateFilters({ search: event.target.value }));
    },
    [dispatch]
  );

  const handleStatusChange = useCallback(
    (event: SelectChangeEvent<string[]>) => {
      const value = event.target.value as string[];
      dispatch(
        updateFilters({
          processingStatus: value as (
            | "pending"
            | "processing"
            | "completed"
            | "failed"
          )[],
        })
      );
    },
    [dispatch]
  );

  const handleAddressChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(updateFilters({ address: event.target.value }));
    },
    [dispatch]
  );

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        mb: 2,
        flexWrap: "wrap",
      }}
    >
      <TextField
        label="Search documents"
        value={filters.search}
        onChange={handleSearchChange}
        size="small"
        sx={{ minWidth: 200 }}
      />

      <TextField
        label="Filter by address"
        value={filters.address || ""}
        onChange={handleAddressChange}
        size="small"
        sx={{ minWidth: 200 }}
      />

      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="status-filter-label">Status</InputLabel>
        <Select
          labelId="status-filter-label"
          multiple
          value={filters.processingStatus || []}
          onChange={handleStatusChange}
          label="Status"
        >
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="processing">Processing</MenuItem>
          <MenuItem value="completed">Completed</MenuItem>
          <MenuItem value="failed">Failed</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};
